import { Principal } from '@icp-sdk/core/principal'

export const to32bits = (num: number): any => {
  const b = new ArrayBuffer(4)
  new DataView(b).setUint32(0, num)
  return Array.from(new Uint8Array(b))
}

export const getExtTokenId = (canister: string, index: number): string => {
  const padding = new Uint8Array([10, 116, 105, 100])
  const array = new Uint8Array([
    ...padding,
    ...Principal.fromText(canister).toUint8Array(),
    ...to32bits(index),
  ])
  return Principal.fromUint8Array(array).toText()
}
